import React from 'react';
import activeAdPopupMod from './indexMod';
import { Modal } from 'antd-mobile';
import { ActiveAdPopup } from 'pubBiz';
import AppMod from 'widget/App/AppMod';

export const fetchData = (params, emptyCallback, closeCallback) => {
  if (params && params.popupPosition) {
    AppMod.changeState('popupPosition', params.popupPosition);
  }
  activeAdPopupMod.getActiveAdList(params).then((res) => {
    const itemInfo = res && res[0];
    const itemInfos = res || [];
    if (itemInfo && (itemInfo.popupRemindType == 4 || itemInfo.popupRemindType == 5)) {
    } else if (itemInfo) {
      renderModal(itemInfo, 0, closeCallback);
    } else {
      emptyCallback && emptyCallback();
    }
  });
};
const renderModal = async (itemInfo, index, closeCallback) => {
  const { popupList } = activeAdPopupMod;
  if (!itemInfo) return;
  let { popupRemindType, mobileTopicId, mobileTopicType, id, mobileContractFlag, thematicId } =
    itemInfo || {};
  if ((itemInfo.buryingPointType || '').includes('1')) {
    window.sensors.track('popupRecord', {
      type: '1',
      popup_id: id, // 弹窗id
      isLogin: !!AppMod.userInfo.token,
      special_page_id: thematicId,
      userId: AppMod.userInfo.id || '',
      channal: 'H5'
    });
  }
  if (popupRemindType === 3) {
    activeAdPopupMod.savePopupRecord(id);
    if (mobileContractFlag) {
      window.app.routerGoTo({
        pathname: '/agreements/topicAgreement',
        state: {
          id: mobileTopicId
        }
      });
    } else {
      let url =
        mobileTopicType == 1
          ? `/shop/home/specialProduct/${mobileTopicId}`
          : mobileTopicType == 4
            ? `/shop/home/special/${mobileTopicId}`
            : `/shop/home/specialClassify/${mobileTopicId}`;
      // 九月开卡活动
      if (mobileTopicId === '1284572010394067054') {
        url = '/shop/home/landingPage';
      }
      window.app.routerGoTo(url);
      return;
    }
    return;
  }
  const modalClose = Modal.alert(
    itemInfo.popupRemindType === 1 ? itemInfo.popupName : null,
    <ActiveAdPopup
      itemInfo={itemInfo}
      onClose={() => {
        modalClose.close();
        activeAdPopupMod.savePopupRecord(itemInfo.id);
        if (!popupList[index + 1]) {
          closeCallback && closeCallback();
          return;
        }
        renderModal(popupList[index + 1], index + 1, closeCallback);
      }}
      onJumpBack={() => {
        modalClose.close();
        activeAdPopupMod.savePopupRecord(itemInfo.id);
      }}
    />,
    [],
    null
  );
  if (itemInfo.popupRemindType === 2 || itemInfo.popupRemindType === 6) {
    const modal = document.getElementsByClassName('am-modal-content');
    if (modal && modal[0]) {
      modal[0].setAttribute('style', 'background: rgba(0,0,0,0)');
    }
  }
};



// WEBPACK FOOTER //
// ./src/pubBiz/ActiveAdPopup/fetchData.js